import initialState from '../store/initialState'
import reportsTypes from '../constants/reportsTypes'

export default function reportsReducer(state = initialState.reports, action) {
  switch (action.type) {
    // case "SET_CURRENT_REPORT":
    //   return {
    //     ...state,
    //     report: action.payload
    //   };
    case reportsTypes.reset_errors:
      return {
        ...state,
        errors: []
      }

    // togle report Actions
    case "SHOW_SIDEBAR_REPORT_ACTIONS":
      return {
        ...state,
        showingProject: true
      }

    case "HIDE_SIDEBAR_REPORT_ACTIONS":
      return {
        ...state,
        showingProject: false
      }

    case "SHOW_ARCHIVE_SIDEBAR_REPORT_ACTIONS":
      return {
        ...state,
        showingProjectArchive: true
      }

    case "HIDE_ARCHIVE_SIDEBAR_REPORT_ACTIONS":
      return {
        ...state,
        showingProjectArchive: false
      }

    // destroy report
    case reportsTypes.destroy.request:
      return {
        ...state,
        destroying: true,
        destroyed: false
      };

    case reportsTypes.destroy.success:
      if (action.payload.report) {
        return {
          ...state,
          destroying: false,
          destroyed: true,
          report: action.payload.report,
          pagination: action.payload.pagination
        };
      } else {
        return {
          ...state,
          destroying: false,
          destroyed: true,
          items: action.payload.reports,
          pagination: action.payload.pagination
        };
      }

    case reportsTypes.destroy.failure:
      return {
        ...state,
        destroying: false,
        destroyed: false
      };

    // archive report
    case reportsTypes.archive.request:
      return {
        ...state,
        setting_trash: true,
        set_trash: false
      };

    case reportsTypes.archive.success:
      if (action.payload.report) {
        return {
          ...state,
          setting_trash: false,
          set_trash: true,
          report: action.payload.report,
          pagination: action.payload.pagination
        };
      } else {
        return {
          ...state,
          setting_trash: false,
          set_trash: true,
          items: action.payload.reports,
          pagination: action.payload.pagination
        };
      }

    case reportsTypes.archive.failure:
      return {
        ...state,
        setting_trash: false,
        set_trash: false,
        errors: action.payload
      }

    // restore report
    case reportsTypes.restore.request:
      return {
        ...state,
        setting_trash: true,
        set_trash: false
      };

    case reportsTypes.restore.success:
      if (action.payload.report) {
        return {
          ...state,
          setting_trash: false,
          set_trash: true,
          report: action.payload.report,
          pagination: action.payload.pagination
        };
      } else {
        return {
          ...state,
          setting_trash: false,
          set_trash: true,
          items: action.payload.reports,
          pagination: action.payload.pagination
        };
      }

    case reportsTypes.restore.success_minimal:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,

      };

    case reportsTypes.restore.failure:
      return {
        ...state,
        setting_trash: false,
        set_trash: false,
        errors: action.payload
      }


    // publish report
    case reportsTypes.publish.request:
      return {
        ...state,
        setting_publish: true,
        set_publish: false
      };

    case reportsTypes.publish.success:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,
        report: action.payload
      };

    case reportsTypes.publish.success_minimal:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,

      };

    case reportsTypes.publish.failure:
      return {
        ...state,
        setting_publish: false,
        set_publish: false,
        errors: action.payload
      }

    // update_xml
    case reportsTypes.update_xml.request:
      return {
        ...state,
        setting_publish: true,
        set_publish: false
      };

    case reportsTypes.update_xml.success:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,
        report: action.payload
      };

    case reportsTypes.update_xml.success_minimal:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,
      };

    case reportsTypes.update_xml.failure:
      return {
        ...state,
        setting_publish: false,
        set_publish: false,
        errors: action.payload
      }


    // unpublish report
    case reportsTypes.unpublish.request:
      return {
        ...state,
        setting_publish: true,
        set_publish: false
      };

    case reportsTypes.unpublish.success:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,
        report: action.payload
      };

    case reportsTypes.unpublish.success_minimal:
      return {
        ...state,
        setting_publish: false,
        set_publish: true,

      };

    case reportsTypes.unpublish.failure:
      return {
        ...state,
        setting_publish: false,
        set_publish: false,
        errors: action.payload
      }


    // GET project
    case reportsTypes.get.request:
      return {
        ...state,
        fetching: true,
        report: {optimizations:[]},
        fetched: false
      };

    // GET project
    case reportsTypes.get.refresh_request:
      return {
        ...state,
        fetching: false,
        fetched: false
      };

    case reportsTypes.get.success:
      return {
        ...state,
        fetching: false,
        fetched: true,
        report: {
          archives: state.report.archives,
          ...action.payload
        }
      };

    case reportsTypes.get.success_excel:
      return {
        ...state,
        fetching: false,
        fetched: true,
      }

    case reportsTypes.get.failure:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }

    case reportsTypes.get.reset_redirect:
      return {
        ...state,
        mustRedirect: false
      };

    // POST CREATE REPORT
    case reportsTypes.create.request:
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      };

    case reportsTypes.create.success:
      return {
        ...state,
        fetching: false,
        fetched: true,
        mustRedirect: true,
        report: action.payload
      };

    case reportsTypes.create.failure:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }

    case reportsTypes.create.after_redirect:
      return {
        ...state,
        mustRedirect: true,
      }

    // POST CREATE OPTIMIZED REPORT
    case reportsTypes.create_optimized.request:
      return {
        ...state,
        creating_optimized: true,
        // fetching: true,
        fetched: false
      };

    case reportsTypes.create_optimized.success:
      return {
        ...state,
        fetching: false,
        fetched: true,
        creating_optimized: false,
        report: action.payload
      };

    case reportsTypes.create_optimized.failure:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }

    // GET project archive
    case reportsTypes.project_archive.request:
      return {
        ...state,
        fetching: true,
        fetching_archive: true,
        fetched: false
      };

    case reportsTypes.project_archive.success:
      return {
        ...state,
        fetching: false,
        fetching_archive: false,
        fetched: true,
        report: action.payload.report
      };

    case reportsTypes.project_archive.failure:
      return {
        ...state,
        fetching: false,
        fetching_archive: false,
        fetched: false,
        errors: action.payload
      }


    // GET REPORTS INDEX
    case reportsTypes.index.request:
      return {
        ...state,
        fetching: true,
        fetched: false
      };

    case reportsTypes.index.success:
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.reports,
        pagination: action.payload.pagination
      };

    case reportsTypes.index.failure:
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }

    // POST PUBLISH_ALL
    case reportsTypes.publish_all.request:
    return {
      ...state,
      setting_publish: true,
      set_publish: false,
      fetching: true,
      fetched: false
    };

    case reportsTypes.publish_all.success:
    return {
      ...state,
      setting_publish: false,
      set_publish: true,
      fetching: false,
      fetched: true,
      items: action.payload.reports,
      pagination: action.payload.pagination
    };

    case reportsTypes.publish_all.failure:
    return {
      ...state,
      setting_publish: false,
      set_publish: false,
      fetching: false,
      fetched: false,
      errors: action.payload
    }

    // POST UN-PUBLISH_ALL
    case reportsTypes.unpublish_all.request:
    return {
      ...state,
      setting_publish: true,
      set_publish: false,
      fetching: true,
      fetched: false
    };

    case reportsTypes.unpublish_all.success:
    return {
      ...state,
      setting_publish: false,
      set_publish: true,
      fetching: false,
      fetched: true,
      items: action.payload.reports,
      pagination: action.payload.pagination
    };

    case reportsTypes.unpublish_all.failure:
    return {
      ...state,
      setting_publish: false,
      set_publish: false,
      fetching: false,
      fetched: false,
      errors: action.payload
    }


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/reportsReducer.js